<script>
    export let player
    export let rank = 0
    $: customClass = rank == 1 ? 'first' : rank == 2 ? 'second' : rank == 3 ? 'third' : rank == 5 || rank == 10 ? 'no-border' : '';
</script>

<span class="wrapper-ranking_table-line {customClass}">
    <span class="wrapper-ranking_table-line_rank">{#if rank == 1}<span class="sprite-pms sprite-pms-crown"></span>{/if}{rank}</span>
    <span class="wrapper-ranking_table-line_pseudo">{ player && player.nickname ? player.nickname : ''}</span>
    <span class="wrapper-ranking_table-line_snowflake">{ player && player.score ? player.score + ' flocons' : ''}</span>
</span>

<style>
	
</style>
